import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient, private authService: AuthService) {}

  private getHeaders(): Observable<HttpHeaders> {
    return from(this.authService.getValidToken()).pipe(
      switchMap(token =>
        from([new HttpHeaders({ Authorization: `Bearer ${token}` })])
      )
    );
  }

  get<T>(path: string): Observable<T> {
    return this.getHeaders().pipe(
      switchMap(headers => this.http.get<T>(`${this.baseUrl}${path}`, { headers }))
    );
  }

  post<T>(path: string, body: any): Observable<T> {
    return this.getHeaders().pipe(
      switchMap(headers =>
        this.http.post<T>(`${this.baseUrl}${path}`, body, { headers })
      )
    );
  }

  postBlob(path: string, body: any): Observable<Blob> {
    return this.getHeaders().pipe(
      switchMap(headers =>
        this.http.post(`${this.baseUrl}${path}`, body, {
          headers,
          responseType: 'blob',
        })
      )
    );
  }

  postFormData<T>(path: string, formData: FormData): Observable<T> {
    return from(this.authService.getValidToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
        return this.http.post<T>(`${this.baseUrl}${path}`, formData, { headers });
      })
    );
  }
}
